import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'slick';
import 'Isotope';

export class enrichpartnerstables {
    private $scope = $('#enrich-points-redeem-wrapper');
    init(): void {
        // this.openAccordion();
        $(".accordion .accord-header:eq(1)").trigger('click');
    }
    nav(): void {
        let $tableAccordianNavList: any = $('.enrich-points-redeem-wrapper li');
        let $tableAccordianNav: any = $('.enrich-points-redeem-wrapper .nav-tabs');
        let $selcetdAccordion: any = $('.panel-default');
        let $iconInactive: any = $('li a img#inactive');
        let $iconActive: any = $('li a img#active');
        let _self = this;
        $selcetdAccordion.find('.panel-title a').click(function (e: any) {
            window.location.hash = $(this).attr("href");
            e.preventDefault();
            
        });
        // $('li a').click(function(){
        //     let hash = window.location.hash;
        //     let anchor = $('a[href$="' + hash + '"]');
        //     let currentActiveTab = anchor.closest('.tab-pane').attr("id");
        //     $('a[href="#' + currentActiveTab + '"] #active').css({
        //         display: 'block'
        //     });
        //     $iconInactive.css({
        //         display: 'none'
        //     });
            
            // $('a[href="#' + currentActiveTab + '"]').parents('ul').find('img.active').removeClass('hide');
        // });
    }
    arrowsHiddenFunction(): void{
        let nextArrow = this.$scope.find('.seq-next');
        let prevArrow = this.$scope.find('.seq-prev');
        let screenwidth = $('.enrich-points-redeem-wrapper').width();
        let items = nextArrow.parents('#enrich-points-redeem-wrapper').find('#nav-tabs');
        let tabCount = items.find('li').length;
        let tabWidth = items.find('li').width();
        let tabGap = parseInt(items.find('li').css('margin-inline-end'));
        let totalWidth = (tabGap + tabWidth) * tabCount;
        if (screenwidth >= totalWidth){
            nextArrow.hide();
            prevArrow.hide();
         }
        else{
            nextArrow.show();
            prevArrow.fadeOut(); 
        }      

    }

    handleGroupNextArrow(): void {
        let nextArrow = this.$scope.find('.seq-next');

        nextArrow.click(function () {
            $(this).parents('#enrich-points-redeem-wrapper').find('.seq-prev').fadeIn();
            let items = $(this).parents('#enrich-points-redeem-wrapper').find('#nav-tabs');
            let itemWidth = items.find('li').width();
            let itemsGap = parseInt(items.find('li').css('margin-inline-end'));
            let totalWidth = itemsGap + itemWidth;
            let scrollWidth = Math.floor(items.width() / totalWidth) * totalWidth;
            items.css("scroll-snap-type", "none");
            $(items).animate({
                scrollLeft: $(items).scrollLeft() + scrollWidth
            }, 500,
                () => {
                    items.css("scroll-snap-type", "x mandatory");
                    if (items.scrollLeft() + items.width() >= items.get(0).scrollWidth) {
                        $(this).fadeOut();
                    }
                });
        });
        
    }
    handleGroupPreviousArrow(): void {
        let prevArrow = this.$scope.find('.seq-prev');

        prevArrow.click(function () {
            $(this).parents('#enrich-points-redeem-wrapper').find('.seq-next').fadeIn();
            let items = $(this).parents('#enrich-points-redeem-wrapper').find('#nav-tabs');
            let itemWidth = items.find('li').width();
            let itemsGap = parseInt(items.find('li').css('margin-inline-end'));
            let totalWidth = itemsGap + itemWidth;
            let scrollWidth = Math.floor(items.width() / totalWidth) * totalWidth;
            items.css("scroll-snap-type", "none");

            if (items.scrollLeft() + items.width() >= items.get(0).scrollWidth) {
                let visibleItems = Math.floor(items.width() / totalWidth) * totalWidth;
                let partialVisibleWidth = items.width() % totalWidth;
                scrollWidth = visibleItems - partialVisibleWidth - itemsGap;
            }

            $(items).animate({
                scrollLeft: $(items).scrollLeft() - scrollWidth
            }, 500,
                () => {
                    items.css("scroll-snap-type", "x mandatory");
                    if (items.scrollLeft() <= 0) {
                        $(this).fadeOut();
                    }
                });


        });
    }
    openAccordion(): void {

        let hash = window.location.hash;
        let anchor = $('a[href$="' + hash + '"]');
      
        if (anchor.length > 0) {
            anchor.click();
            anchor.closest('.tab-pane').parent().children().removeClass('active in');
            anchor.closest('.tab-pane').addClass('active in');
            let currentActiveTab = anchor.closest('.tab-pane').attr("id");
            $('a[href="#' + currentActiveTab + '"]').parents('ul').children('li').removeClass('active');
            $('a[href="#' + currentActiveTab + '"]').closest('li').addClass('active');
          
            setTimeout(function () { document.querySelector('.enrich-points-redeem-wrapper').scrollIntoView(); }, 3000);
        }
        
        let bgColor = $('[data-background-colorId]').attr('data-background-colorId');
        if(bgColor != "" && bgColor != null){
            $(' .tab-content .panel.panel-default:nth-child(even)').css({
                background : bgColor
            });
            $('.enrich-points-redeem-wrapper').css({background : bgColor})
        }
        else{
            $(' .tab-content .panel.panel-default:nth-child(even)').css({
                background : '#f1f1f1'
            });
            $('.enrich-points-redeem-wrapper').css({background : '#f1f1f1'})
        }


    }
}

let scope: Element = document.querySelector('#enrichPartnersAcoordionContaniner');
if (scope) {
    try {
        let enrichpartnerstable: any = new enrichpartnerstables();
        enrichpartnerstable.init();
        enrichpartnerstable.nav();
        enrichpartnerstable.openAccordion();
        enrichpartnerstable.handleGroupNextArrow();
        enrichpartnerstable.handleGroupPreviousArrow();
        enrichpartnerstable.arrowsHiddenFunction();
    } catch (e) { console.error(e); }
}
